/**
 * @file Blog / Blog post related constants.
 */

/**
 * @enum BLOG_POST_STATUS
 * @type {{PUBLISHED: string, DRAFT: string}}
 */
const BLOG_POST_STATUS = {
  PUBLISHED: 'PUBLISHED',
  DRAFT: 'DRAFT',
};

/**
 * @enum BLOG_POST_LINK_TYPE
 * @type {{ALBUM_PHOTO_GROUP: string, ALBUM: string, ALBUM_FOLDER: string}}
 */
const BLOG_POST_LINK_TYPE = {
  ALBUM_FOLDER: 'ALBUM_FOLDER',
  ALBUM: 'ALBUM',
  ALBUM_PHOTO_GROUP: 'ALBUM_PHOTO_GROUP',
};

/**
 * @enum BLOG_POST_LINK_TYPE_LABEL
 * @type {{}}
 */
const BLOG_POST_LINK_TYPE_LABEL = {
  [BLOG_POST_LINK_TYPE.ALBUM_FOLDER]: 'Subfolder',
  [BLOG_POST_LINK_TYPE.ALBUM]: 'Album',
  [BLOG_POST_LINK_TYPE.ALBUM_PHOTO_GROUP]: 'Subalbum',
};

/**
 * Blog post fetch limit for PRO admin.
 *
 * @type {number}
 */
const BLOG_POST_FETCH_LIMIT = 20;

/**
 * Blog post cover photo fetch limit for PRO admin.
 *
 * @type {number}
 */
const BLOG_POST_COVER_PHOTO_FETCH_LIMIT = 100;

export {
  BLOG_POST_STATUS,
  BLOG_POST_FETCH_LIMIT,
  BLOG_POST_COVER_PHOTO_FETCH_LIMIT,
  BLOG_POST_LINK_TYPE,
  BLOG_POST_LINK_TYPE_LABEL,
};
